export const featureFlag = {
  switchIn: 'Redtail_Imaging_SwitchIn',
  fileStats: 'Redtail_Imaging_FileStatsChart',
  folderColors: 'Redtail_Imaging_FolderColors',
  maintenanceMode: 'Redtail_Imaging_MaintenanceMode',
  sharing: 'Redtail_Imaging_Sharing'
};

export type FeatureFlag = (typeof featureFlag)[keyof typeof featureFlag];
